module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[87]574.044b6b2.woff2";